import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-license-credential-prompt',
	templateUrl: './license-credential-prompt.component.html',
	styleUrls: ['./../online-order.component.scss'],
})
export class LicenseCredentialPromptComponent implements OnInit {
	@Input() display: boolean = true;
	@Input() header: string;

	@Output() licenseCredentialChange = new EventEmitter();

	licenseKey: string;
	licenseSecret: string;

	constructor() {}

	ngOnInit(): void {}

	submit() {
		this.licenseCredentialChange.emit({
			licenseKey: this.licenseKey,
			licenseSecret: this.licenseSecret,
		});
	}
}
